module.exports = __webpack_public_path__ + "static/Service-Rectangle-40-cd10094ae9a68a9f4038b45798781c84.png";